class SliderAuto {
	constructor() {
		this.sliders = document.querySelectorAll(".slider-auto");

		if(!this.sliders) {
			return;
		}

		this.buildSliders();
	}

	buildSliders() {
		this.sliders.forEach(slider => {
			const slides = slider.querySelectorAll(".swiper-slide");
			const swiper = new Swiper(slider, {
				loop: true,
				slidesPerView: "auto",
				centeredSlides: true,
				loopedSlides: slides.length,
				spaceBetween: "2%",
				speed: 6000,
				autoplay: {
					delay: 1,
				},
				allowTouchMove: false,
				disableOnInteraction: true
			});
		});
	}
}